export function handleFormChange(callback: (value: any) => void) {
  return (event: React.FormEvent<HTMLSelectElement|HTMLInputElement>) => {
    let value = event.currentTarget.type === 'checkbox' ?
      event.currentTarget['checked'] : event.currentTarget.value;
    callback(value);
  };
}